import theme from '../../styles/theme';
export const sizes = {
    large: 'large',
    medium: 'medium',
    small: 'small',
};
export const textFontSizes = {
    [sizes.small]: theme.typeStyles.bodySmallStyles,
    [sizes.medium]: theme.typeStyles.bodyMediumStyles,
    [sizes.large]: theme.typeStyles.bodyLargeStyles,
};
